import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { masterDataFeature } from 'app/state/master-data/master-data.reducer';

import { MasterDataEffects } from './master-data.effects';

@NgModule({
    declarations: [],
    imports: [StoreModule.forFeature(masterDataFeature), EffectsModule.forFeature([MasterDataEffects])],
})
export class MasterDataStateModule {}
